<template>
  <div class="navigation-tabs-block" :class="{ hidden: !visible }">
    <span class="navigation-tabs-item active">Personas</span>
    <a class="navigation-tabs-item" :href="wording.buttons.web_pj_link" target="_blank" aria-label="Ir al portal de Banca Empresas" @click="gtagEvents">Empresas</a>
  </div>
</template>

<script>

export default {
  name: 'navigation-tabs',
  data: () => {
    return {
      visible: false,
    }
  },
  beforeMount() {
    this.wording = this.$store.state.wording.data.attributes
  },
  mounted() {
  setTimeout(() => {
    this.visible = true
  }, 0)
  },
  methods: {
  gtagEvents() {
    window.gtag('event', 'web_button_click', {
      'event_category': 'navigation',
      'event_label': 'navigation_tabs'
    })
  }
}
}
</script>

<style lang="less">
@import "../../styles/vars.less";

.navigation-tabs-block {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 48px;
  padding: 8px 0 0 48px;
  z-index: 4;

  background: #DFE7F2;
  border-bottom: 1px solid #889EBF;
  transform-origin: top left;

  transition: transform 0.6s @custom-ease-1, opacity 1.2s @custom-ease-1;

  &.hidden {
    transform: translate(-100%, 0);
    opacity: 0;
  }
  @media screen and (max-width: @tablet) {
    padding: 8px 0 0 16px;
  }

  .navigation-tabs-item {
    position: relative;
    display: inline-block;
    top: -1px;
    padding: 12px 16px;

    border-bottom: none;

    font-family: @bold;
    color: #5E718D;
    font-size: 0.75rem;
    line-height: 1rem;

    &.active {
      border-radius: 8px 8px 0 0;
      border: 1px solid #889EBF;
      border-bottom: none;
      background-color: fade(@white, 99%);
      color: initial;
    }
  }
  &+.navigation {
    top: 48px;
  }

}
</style>